@if (label()) {
    <form-label
        [id]="id() + '-label'"
        [forId]="id() + '-input-text'"
        [label]="label()"
        [required]="required()"
        [tooltipText]="tooltipText()"
        [hasError]="invalid()">
    </form-label>
}

<p-iconField iconPosition="right">
    <ng-container [ngTemplateOutlet]="inputTextTemplate"></ng-container>
    @if (showClearIcon() && value() && value().length > 0 && !disabled()) {
        <p-inputIcon styleClass="fa-solid fa-xmark input-clear-icon" (click)="clearInput($event)" role="button" />
    }
    @if (tooltipError() !== undefined && invalid()) {
        <p-inputIcon styleClass="fa-sharp fa-solid fa-circle-exclamation" />
    }
</p-iconField>

<ng-template #inputTextTemplate>
    <input
        pInputText
        [id]="id() + '-input-text'"
        [pTooltip]="tooltipError() || '' | translate"
        [tooltipDisabled]="!invalid() || !tooltipError()"
        [tooltipPosition]="tooltipErrorPlacement()"
        [tooltipStyleClass]="'input-error-tooltip'"
        [escape]="false"
        [type]="type()"
        [placeholder]="placeholder() | translate"
        [disabled]="disabled()"
        [maxLength]="maxLength()"
        [invalid]="invalid()"
        [class.glue-left]="glueLeft()"
        [class.glue-right]="glueRight()"
        [class.ng-invalid]="invalid()"
        [class.ng-dirty]="invalid()"
        [fluid]="true"
        [pSize]="size()"
        [(ngModel)]="value"
        (blur)="onBlur.emit(this.value())"
        (focus)="inputFocus()" />
    <ng-content></ng-content>
</ng-template>
